import { useState } from 'react';
import DateRange from "../../../components/DateRange/DateRange";
import DateFilterInfoPopup from '../../../components/Popover/DateFilterInfoPopup';
import { accessKeys } from '../../../statics/accessKeys';
import { accessCheck } from '../../../utils/accessCheck';
import ChatActivityGraph from '../Component/ReportComponents/ChatActivityGraph';
import ChatAnalyticsCards from '../Component/ReportComponents/ChatAnalyticsCards';
import ChatFeedbackReport from '../Component/ReportComponents/ChatFeedbackReport';
import ChatOperatorPiChart from '../Component/ReportComponents/ChatOperatorPiChart';
import ChatOperatorReport from '../Component/ReportComponents/ChatOperatorReport';

const ChatReports = () => {

    const [selected, setSelected] = useState(2);
    const [date, setDate] = useState({ startDate: '', endDate: '' });
    const [selectedOperator, setSelectedOperator] = useState(null);

    function onDateChange(p) {
        let newDate = { startDate: p.startDate._d, endDate: p.endDate._d }
        setDate(newDate)
    }

    function handleOnChange(value) {
        setSelected(parseInt(value));
        if (value !== 3) {
            setDate({ startDate: '', endDate: '' })
        }
    }

    return (
        <>
            <div className="flex items-center justify-between gap-2 !mb-3">
                <p className='font-semibold text-sm'>Report</p>
                <div className='flex ms-auto gap-2'>
                    <select name="" id="" className='form-control form-control-sm' defaultValue={selected} onChange={(e) => { handleOnChange(e?.target?.value) }}>
                        <option value="1">Today</option>
                        <option value="2">Last 7 Days</option>
                        <option value="3">Custom</option>
                    </select>
                </div>
                {selected == 3 && <DateRange onApplyClick={(date) => onDateChange(date)} date={date} />}
                {date?.startDate && <DateFilterInfoPopup />}
            </div>

            <ChatAnalyticsCards date={date} selected={selected} />

            <ChatActivityGraph date={date} selected={selected} />

            {accessCheck(accessKeys?.operatorDetails) && <ChatOperatorReport setSelectedOperator={setSelectedOperator} selectedOperator={selectedOperator} />}

            <div className="grid grid-cols-1 md:grid-cols-2 !gap-4">
                <ChatFeedbackReport />
                {accessCheck(accessKeys?.operatorDetails) && <ChatOperatorPiChart selectedOperator={selectedOperator} />}
            </div>
        </>
    )
}

export default ChatReports